import React, { useState, useEffect, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL";

const PPTrackingDashboard = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  const [rowData, setRowData] = useState([]);
  const [currentDate, setCurrentDate] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  });

  const sideBar = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
        },
        {
          id: "filters",
          labelDefault: "Filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
        },
      ],
    }),
    []
  );

  const statusPanel = {
    statusPanels: [
      { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
      { statusPanel: "agTotalRowCountComponent", align: "center" },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" },
    ],
  };

  // Helper functions
  const pad2 = (n) => String(n).padStart(2, "0");
  const todayYMD = () => {
    const d = new Date();
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  };

  const closeAlert = () => setShow(false);

  const toYMD = (v) => {
    if (!v) return "";
    if (typeof v === "object" && v.$date != null) v = v.$date;
    if (typeof v === "number") {
      const dNum = v > 1000000000000 ? v : v * 1000;
      const d = new Date(dNum);
      return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    }
    if (v instanceof Date) {
      return `${v.getFullYear()}-${pad2(v.getMonth() + 1)}-${pad2(v.getDate())}`;
    }
    if (typeof v === "string") {
      const iso = v.match(/(\d{4}-\d{2}-\d{2})/);
      if (iso) return iso[1];
      const dmy = v.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
      if (dmy) return `${dmy[3]}-${dmy[2]}-${dmy[1]}`;
      const d2 = new Date(v);
      if (!isNaN(d2)) return `${d2.getFullYear()}-${pad2(d2.getMonth() + 1)}-${pad2(d2.getDate())}`;
    }
    return "";
  };

  // Date input styles
  const dateLabel = { fontSize: "13px", fontWeight: 400 };
  const dateInput = {
    padding: "7px",
    borderRadius: "5px",
    border: "1px solid #d9d9d9",
    width: "100%",
    marginBottom: "0px",
    cursor: "pointer",
  };
  const applyBtn = {
    backgroundColor: "#93385D",
    color: "#fff",
    borderRadius: "5px",
    padding: "8px 20px",
    border: "none",
    cursor: "pointer",
    marginRight: "20px",
    marginTop: "5px"
  };
  const resetBtn = {
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "5px",
    padding: "8px 20px",
    border: "1px solid #d9d9d9",
    cursor: "pointer",
  };

  // Column definitions for PP Tracking
  const columnDefs = [
    // { 
    //   headerName: "Sr no.", 
    //   width: 100,
    //   valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : ''),
    //   sortable: false,
    //   filter: false
    // },
    { 
      headerName: "Batch No.", 
      field: "batch_no",
      width: 150,
    },
    { 
      headerName: "Variant", 
      field: "variant",
      width: 100
    },
    { 
      headerName: "Planned Production", 
      field: "planned_production",
      width: 160,
    //   type: "numericColumn",
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Actual Production", 
      field: "actual_production",
      width: 160,
    //   type: "numericColumn",
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Quality Control Sample", 
      field: "quality_control_sample",
      minWidth: 180,
    //   type: "numericColumn",
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Handover to Ops", 
      field: "handover_to_ops",
      width: 160,
    //   type: "numericColumn",
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Difference", 
      field: "difference",
      width: 120,
    //   type: "numericColumn",
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : "",
    
    },
    { 
      headerName: "Requested By", 
      field: "requested_by",
      width: 150
    },
    { 
      headerName: "Date", 
      field: "date",
      width: 120,
      valueGetter: (params) => toYMD(params.data?.date)
    },
    { 
      headerName: "From", 
      field: "from",
      width: 120
    },
    { 
      headerName: "Destination", 
      field: "destination",
      width: 140
    },
    { 
      headerName: "SKU", 
      field: "sku",
      width: 120
    },
    { 
      headerName: "SKU Description", 
      field: "sku_description_auto_fill",
      width: 200
    },
    { 
      headerName: "Category", 
      field: "category",
      width: 140
    },
    { 
      headerName: "M DATE", 
      field: "m_date",
      width: 120,
      valueGetter: (params) => toYMD(params.data?.m_date)
    },
    { 
      headerName: "Requested Quantity", 
      field: "requested_quantity",
      width: 160,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Dispatched Quantity", 
      field: "dispatched_quantity",
      width: 160,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Dispatched Boxes Count", 
      field: "dispatched_boxes_count",
      width: 180,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Excess/Short Dispatched", 
      field: "excess_short_dispatched",
      width: 180,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Received Quantity", 
      field: "received_quantity",
      width: 160,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Received Boxes Count", 
      field: "received_boxes_count",
      width: 180,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Dispatch Date", 
      field: "dispatch_date",
      width: 140,
      valueGetter: (params) => toYMD(params.data?.dispatch_date)
    },
    { 
      headerName: "Tentative Delivery Date", 
      field: "tentative_delivery_date",
      width: 180,
      valueGetter: (params) => toYMD(params.data?.tentative_delivery_date)
    },
    { 
      headerName: "Actual Delivery Date", 
      field: "actual_delivery_date",
      width: 180,
      valueGetter: (params) => toYMD(params.data?.actual_delivery_date)
    },
  { 
    headerName: "Warehouse", 
    field: "warehouse",
    width: 140,
    valueFormatter: (params) => {
      if (!params.value || params.value === "nan" || params.value === "null") return "";
      return params.value;
    }
  },
    { 
      headerName: "Total In Quantity", 
      field: "total_in_qauntity",
      width: 160,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Inward Quantity Difference", 
      field: "inward_quantity_difference",
      minWidth: 200,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Channel", 
      field: "channel",
      width: 120
    },
    { 
      headerName: "Sub Channel", 
      field: "sub_channel",
      width: 140
    },
    { 
      headerName: "Date of Packing", 
      field: "date_of_packing",
      width: 150,
      valueGetter: (params) => toYMD(params.data?.date_of_packing)
    },
  { 
    headerName: "PO Warehouse Name", 
    field: "po_warehouse_name",
    minWidth: 180,
    valueFormatter: (params) => {
      if (!params.value || params.value === "nan" || params.value === "null") return "";
      return params.value;
    }
  },
    { 
      headerName: "PO Number/Order Number", 
      field: "po_number_order_number",
      minWidth: 200
    },
    { 
      headerName: "Quantity", 
      field: "quantity",
      width: 120,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Total Out Quantity", 
      field: "total_out_quantity",
      width: 160,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Outward Quantity Difference", 
      field: "outward_quantity_difference",
      minWidth: 200,
    //   valueFormatter: (params) => params.value != null ? Number(params.value).toLocaleString() : ""
    },
    { 
      headerName: "Inserted Date", 
      field: "inserted_date",
      width: 150,
      hide:true,
      valueGetter: (params) => toYMD(params.data?.inserted_date)
    }
  ];

  const defaultColDef = useMemo(
    () => ({ 
      sortable: true, 
      filter: true, 
      resizable: true, 
      flex: 1, 
      minWidth: 150,
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      }
    }),
    []
  );

  const fetchData = async (dateStr) => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    try {
      const payload = { current_date: dateStr || currentDate };
      const resp = await redirectURL.post("inventory/getPPTrackingDashboardData", payload);
      
      if (!resp || !resp.data) throw new Error("No response from server");

      const status = String(resp.data.status || "").toLowerCase();
      if (status === "fail") {
        const msgTxt = resp.data.message ? String(resp.data.message) : "Server returned failure";
        throw new Error(msgTxt);
      }
      if (status !== "success") throw new Error("Invalid response format from server");

      const messageData = resp.data.message || {};
      
      // Parse final_pp_tracking_info if it's a string
      let trackingData = [];
      if (messageData.final_pp_tracking_info) {
        if (typeof messageData.final_pp_tracking_info === "string") {
          try {
            trackingData = JSON.parse(messageData.final_pp_tracking_info);
          } catch (e) {
            console.error("Error parsing final_pp_tracking_info:", e);
            trackingData = [];
          }
        } else if (Array.isArray(messageData.final_pp_tracking_info)) {
          trackingData = messageData.final_pp_tracking_info;
        }
      }

      setRowData(trackingData);

     if (trackingData.length === 0) {
        let noDataMsg = "No PP Tracking data available for the selected date.";
        if (typeof resp.data.message === "string") {
          noDataMsg = resp.data.message;
        }
        else if (resp.data.message && typeof resp.data.message.message === "string") {
          noDataMsg = resp.data.message.message;
        }
        setBasicTitle(noDataMsg);
        setBasicType("warning");
        setShow(true);
      }
    } catch (e) {
      const emsg = e && e.message ? e.message : "Unknown error";
      setBasicTitle("Failed to fetch PP Tracking Dashboard: " + emsg);
      setBasicType("error");
      setShow(true);
      setRowData([]);
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  useEffect(() => {
    fetchData(currentDate);
  }, []);

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12 pl-0">
            <h1
              className="col-sm-12"
              style={{ color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif" }}
            >
              PP Tracking Dashboard
            </h1>
          </div>

          <div className="col-sm-8 row pl-1 mt-2 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-4">
              <label htmlFor="currentDate" style={dateLabel}>Current Date:</label>
              <input
                type="date"
                id="currentDate"
                value={currentDate}
                onChange={(e) => setCurrentDate(e.target.value)}
                onClick={() => document.getElementById("currentDate").showPicker?.()}
                style={dateInput}
                max={todayYMD()}
              />
            </div>

            <div className="col-6 mt-4">
              <button 
                type="button" 
                onClick={(e) => { e.preventDefault(); fetchData(currentDate); }} 
                style={applyBtn}
              >
                Apply
              </button>

              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  const d = todayYMD();
                  setCurrentDate(d);
                  fetchData(d);
                }}
                style={resetBtn}
              >
                Reset
              </button>
            </div>
          </div>

          {/* Data Grid */}
          <div className="col-sm-12 p-0 pl-2">
            <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                pagination={true}
                paginationPageSize={500}
                enableRangeSelection={true}
                suppressFieldDotNotation={true}
                overlayNoRowsTemplate="No PP Tracking data available"
                sideBar={sideBar}
                statusBar={statusPanel}
                onGridReady={(params) => { 
                  if (params && params.api) params.api.sizeColumnsToFit(); 
                }}
                onFirstDataRendered={(params) => { 
                  if (params && params.api) params.api.sizeColumnsToFit(); 
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
    </>
  );
};

export default PPTrackingDashboard;